import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import { AppLogo } from "nvent-web/components/AppLogo/AppLogo";

import Heading from "../../components/Heading";

export const RegistrationHeading: FC = () => (
  <>
    <AppLogo />
    <Heading
      title={<FormattedMessage id="register.heading" />}
      description={<FormattedMessage id="register.description" />}
    />
  </>
);

export default RegistrationHeading;
